import { SortingIndicator } from '../Buttons/SortIndicator';
import { useGridApiContext } from '@mui/x-data-grid-pro';
import { useFieldSortModel } from '../../hooks/useFieldSortModel';
import { toggleSorting } from 'src/common/components/Filters/constants/sorting';
import { styled } from '@mui/material/styles';

type SortableHeaderFieldProps = {
  field: string;
  'data-testid'?: string;
};

const SortableHeaderIdicatorRoot = styled('div')(({ theme }) => ({
  height: theme.spacing(16),
}));

export const SortableHeaderIdicator = ({ field, ...props }: SortableHeaderFieldProps) => {
  const apiRef = useGridApiContext();
  const soratbleData = useFieldSortModel(field);

  return (
    <SortableHeaderIdicatorRoot className={soratbleData ? '' : 'sort'}>
      <SortingIndicator
        {...props}
        direction={soratbleData?.sort}
        onClick={(e) => {
          e.stopPropagation();
          apiRef.current.setSortModel([
            {
              field,
              sort: toggleSorting(soratbleData?.sort),
            },
          ]);
        }}
      />
    </SortableHeaderIdicatorRoot>
  );
};
